import * as ACTIONS from '../actions/locator'

export default function reducer (state = {
  loading: false,
  error: false,
  stores: [],
  locations: [],
  currentStore: null,
  recentLocations: [],
  currentStoreIndex: null,
  searchTerm: null,
  viewType: 0,
  azListVisible: true,
  azList: []
}, action) {
  switch (action.type) {
    case ACTIONS.FETCH_STORES: {
      return {...state, loading: true}
    }
    case ACTIONS.FETCH_STORES_REJECTED: {
      return {...state, loading: false, error: action.payload}
    }
    case ACTIONS.FETCH_STORES_FULFILLED_NO_STORES: {
      return {...state, loading: false, error: false, stores: [], locations: action.payload}
    }
    case ACTIONS.FETCH_STORES_FULFILLED: {
      return {...state, loading: false, error: false, stores: action.payload.filter(n => n !== null), locations: []}
    }
    case ACTIONS.SET_CURRENT_STORE: {
      return {...state, currentStore: action.payload.id, currentStoreIndex: action.payload.order}
    }
    case ACTIONS.SET_CURRENT_LOCATION: {
      return {...state, loading: false, currentLocation: action.payload}
    }
    case ACTIONS.SET_LOADING: {
      return {...state, loading: action.payload}
    }
    case ACTIONS.FETCH_RECENTLY_SEARCHED_LOCATIONS_FULFILLED: {
      return {...state, recentLocations: action.payload}
    }
    case ACTIONS.FETCH_RECENTLY_SEARCHED_LOCATIONS_REJECTED: {
      return {...state, recentLocations: action.payload}
    }
    case ACTIONS.SAVE_RECENTLY_SEARCHED_LOCATION: {
      return {...state, recentLocations: action.payload}
    }
    case ACTIONS.SET_VIEW_TYPE: {
      return {...state, viewType: action.payload}
    }
    case ACTIONS.SET_AZ_LIST_VISIBLE: {
      return {...state, azListVisible: action.payload}
    }
    case ACTIONS.SAVE_SEARCH_TERM: {
      return {...state, searchTerm: action.payload}
    }
    case ACTIONS.FETCH_ALL_STORES_FULFILLED: {
      return {...state, azList: action.payload}
    }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/locator.js